import { useLocation, useNavigate, useParams } from 'react-router-dom';

export function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        const location = useLocation();
        const navigate = useNavigate();
        const params = useParams();

        const history = {
            push: (to) => navigate(to),
            replace: (to) => navigate(to, { replace: true }),
            go: (n) => navigate(n),
            goBack: () => navigate(-1),
            goForward: () => navigate(1),
            listen: (callback) => {
                // v6 doesn't have history.listen, return noop
                return () => {};
            },
            location,
        };

        return (
            <Component
                {...props}
                location={location}
                navigate={navigate}
                history={history}
                match={{ params }}
            />
        );
    }

    return ComponentWithRouterProp;
}
